export default __webpack_public_path__ + "static/media/9E056FA1-0C1C-4F37-9A22-936217D21CB7_1_105_c.05e45812.jpeg";